import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { ChurnFlowInsightsService } from '@core/churn-flow-logic';
import {
  ChurnFlowInsightCardComponent,
  ChurnFlowTellentImpactLogoComponent,
} from '@core/churn-flow-ui';
import { injectTranslate } from '@core/i18n-legacy';
import { HeadingComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-churn-flow-insights',
  templateUrl: './churn-flow-insights.component.html',
  styleUrls: ['./churn-flow-insights.component.less'],
  imports: [HeadingComponent, ChurnFlowInsightCardComponent, ChurnFlowTellentImpactLogoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChurnFlowInsightsComponent {
  private readonly t = injectTranslate();
  private readonly churnFlowDataService = inject(ChurnFlowInsightsService);

  public showInsights = this.churnFlowDataService.showImpactTrackerInsightsSignal;
  public impactTrackerCards = this.churnFlowDataService.insightsCards;

  public heading = computed(() =>
    this.showInsights()
      ? this.t('tlc.churn_flow.insights.heading')
      : this.t('tlc.churn_flow.insights.fallback.heading'),
  );

  public subheading = computed(() =>
    this.showInsights()
      ? this.t('tlc.churn_flow.insights.subheading')
      : this.t('tlc.churn_flow.insights.fallback.subheading'),
  );
}
